(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-cross-sell"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-xs-add]');
  if (!btn || btn.disabled || btn.dataset.busy) return;
  e.preventDefault();
  var vid = btn.getAttribute('data-variant-id');
  if (!vid) return;
  var label = btn.querySelector('[data-xs-add-text]');
  var orig = label ? label.textContent : '';
  btn.dataset.busy = '1';
  if (label) label.textContent = 'Adding…';

  // JSON items add — bypasses the helper that injects the page's selling_plan
  // into form/urlencoded adds (which 422s for a non-subscription product).
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
  })
    .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
    .then(function (res) {
      if (!res.ok) throw new Error((res.d && res.d.description) || 'Add failed');
      btn.classList.add('is-added');
      if (label) label.textContent = 'Added ✓';
      // Refresh + open the theme cart drawer.
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('theme:cart-drawer:open', { bubbles: true, detail: {} }));
      setTimeout(function () { btn.classList.remove('is-added'); if (label) label.textContent = orig; btn.dataset.busy = ''; }, 2500);
    })
    .catch(function (err) {
      if (label) label.textContent = 'Try again';
      btn.dataset.busy = '';
      setTimeout(function () { if (label) label.textContent = orig; }, 2500);
      if (window.console) console.warn('[cross-sell] add failed', err);
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-ingredients-tabs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var tab = e.target.closest('.ing-tab');
  if (tab) {
    var root = tab.closest('[data-section-type="ingredients-tabs"]');
    if (!root) return;
    var group = tab.getAttribute('data-group');
    root.querySelectorAll('.ing-tab').forEach(function (t) { t.classList.toggle('is-active', t === tab); });
    root.querySelectorAll('.ing-panel').forEach(function (p) { p.classList.toggle('is-hidden', p.getAttribute('data-panel') !== group); });
    return;
  }
  var card = e.target.closest('.ing-card');
  if (card) {
    var dialog = document.getElementById(card.getAttribute('data-dialog'));
    if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
  }
});

// Infinite-loop carousel. Works on mobile + desktop (both are carousels now).
// Only loops a row that actually overflows; clones are appended so scrolling
// wraps seamlessly. Re-inits on tab switch and in the theme editor.
(function () {
  function initLoop(row) {
    if (!row || row.dataset.looped) return;
    if (row.scrollWidth <= row.clientWidth + 4) return; // fits — nothing to loop
    var originals = Array.prototype.slice.call(row.querySelectorAll('.ing-card:not([data-clone])'));
    if (originals.length < 2) return;
    for (var c = 0; c < 2; c++) {
      originals.forEach(function (cardEl) {
        var clone = cardEl.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('tabindex', '-1');
        clone.dataset.clone = '1';
        row.appendChild(clone);
      });
    }
    row.dataset.looped = '1';
    row.scrollLeft = row.scrollWidth / 3; // start in the middle copy
    // Recenter only AFTER scrolling settles, so we never interrupt momentum
    // (mid-scroll jumps are what caused the jitter). The jump is instant and
    // lands on identical cloned content, so it's imperceptible.
    var settle;
    row.addEventListener('scroll', function () {
      clearTimeout(settle);
      settle = setTimeout(function () {
        var one = row.scrollWidth / 3;
        if (row.scrollLeft < one * 0.5) row.scrollLeft += one;
        else if (row.scrollLeft > one * 1.5) row.scrollLeft -= one;
      }, 120);
    }, { passive: true });
  }
  function initAll() {
    document.querySelectorAll('[data-section-type="ingredients-tabs"] .ing-panel:not(.is-hidden) .ing-row').forEach(initLoop);
  }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  // a newly shown tab's row may now be measurable
  document.addEventListener('click', function (e) { if (e.target.closest('.ing-tab')) setTimeout(initAll, 30); });
  // theme editor re-render
  document.addEventListener('shopify:section:load', function () { setTimeout(initAll, 30); });
})();

  } catch(e) { console.error(e); }
})();
})();
